import { render, staticRenderFns } from "./DetailOneAsset_new.vue?vue&type=template&id=68514cd0&scoped=true&"
import script from "./DetailOneAsset_new.vue?vue&type=script&lang=js&"
export * from "./DetailOneAsset_new.vue?vue&type=script&lang=js&"
import style0 from "./DetailOneAsset_new.vue?vue&type=style&index=0&id=68514cd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68514cd0",
  null
  
)

export default component.exports